/* pg-cart-express */
(function(){
  if (window.pgCartExpress) return; window.pgCartExpress = 1;

  /* Read NOW, while the page is still being parsed: this script sits right
     after the holder, so the markup is exactly what Shopify rendered, before
     the wallet script has had a chance to draw anything inside it. An empty
     shell means there is no wallet to offer. */
  var KEEP = {apple_pay: 1, google_pay: 1};
  var MARKUP = '', HOLDER_COMP = false;
/* markup counts only when it carries a wallet this pane will show: Shopify renders a component for an EMPTY cart too, with no wallets in it, and that copy used to satisfy the length test and block the cart-page seed for the rest of the visit (2026-09-24) */
function usable(s){
if (!s || s.length < 40 || !/shopify-accelerated-checkout/.test(s)) return false;
try {
var tmp = document.createElement('div'); tmp.innerHTML = s;
var comp = tmp.querySelector('shopify-accelerated-checkout-cart');
var cfg = comp ? JSON.parse(comp.getAttribute('wallet-configs') || '[]') : [];
return cfg.some(function(w){ return w && KEEP[w.name]; });
} catch (e){ return false; }
}
  (function(){
    var h = document.getElementById('pg-xpay-holder');
    var s = h ? (h.innerHTML || '').trim() : '';
    /* 2026-09-24: the holder now arrives with only the empty dynamic-checkout-cart div (115 chars), which used to pass this length test and block the cart-page seed below; only real component markup counts */
if (usable(s)) MARKUP = s;
    /* THE HOLDER ITSELF IS CUT DOWN TOO, and for speed: left whole, the hidden
       copy would load the Shop Pay, Amazon Pay and PayPal scripts and iframes
       on every page of the site for buttons nobody can see. It keeps only the
       wallet the pane will show, and is dropped outright when there is none. */
    var comp = h && h.querySelector('shopify-accelerated-checkout-cart');
    HOLDER_COMP = !!comp;
    if (!comp) return;
    try {
      var cfg = JSON.parse(comp.getAttribute('wallet-configs') || '[]').filter(function(w){ return w && KEEP[w.name]; });
      if (cfg.length) comp.setAttribute('wallet-configs', JSON.stringify(cfg));
      else if (comp.parentNode) comp.parentNode.removeChild(comp);
    } catch (e){}
  })();

  /* 2026-09-24: Shopify no longer renders the wallet component into the holder on product pages (only the empty dynamic-checkout-cart div arrives, and the portable-wallets module is not even loaded), so the markup is taken from the CART PAGE instead - one fetch of /cart, the component copied out of its dynamic-checkout-cart div - and the module is loaded through Shopify.PaymentButton.init(), the same call the cart page makes. Without this the wallet row had silently disappeared everywhere (owner 2026-09-24: "where did Apple Pay and Google Pay go"). */
var SEEDING = false, SEEDED = false, SEED_AT = 0;
/* 2026-10-13 (speed): what a /cart read found is remembered (sessionStorage, per currency, country and language). Usable wallet markup is kept for the visit. A cart page that HELD LINES and offered wallets, but neither Apple Pay nor Google Pay (a browser Shopify offers neither to, e.g. desktop Chrome), is remembered as 'none' for 10 minutes instead of being asked again: every drawer mutation used to re-ask at most every 8 s and download the whole cart page (728 KB, 165 KB gzipped) for the same answer. An empty cart's page is never taken as a verdict. */
var SKEY = 'pgxWallet|' + (function(){ try { var S = window.Shopify || {}; return [(S.currency && S.currency.active) || '', S.country || '', S.locale || ''].join('|'); } catch (e){ return ''; } })();
function memoGet(){ try { return sessionStorage.getItem(SKEY) || ''; } catch (e){ return ''; } }
function memoPut(v){ try { sessionStorage.setItem(SKEY, v); } catch (e){} }
function walletCount(s){
try {
var tmp = document.createElement('div'); tmp.innerHTML = s;
var comp = tmp.querySelector('shopify-accelerated-checkout-cart');
return comp ? JSON.parse(comp.getAttribute('wallet-configs') || '[]').length : 0;
} catch (e){ return 0; }
}
function seed(){
if (MARKUP || SEEDED || SEEDING) return;
var kept = memoGet();
if (/^none:\d+$/.test(kept) && Date.now() - parseInt(kept.slice(5), 10) < 600000) return;
if (kept && usable(kept)){
MARKUP = kept; SEEDED = true;
if (!(window.customElements && customElements.get('shopify-accelerated-checkout-cart'))){
try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init(); } catch (e){}
}
setTimeout(place, 50);
return;
}
/* an EMPTY cart page carries no component either, so a miss is retried (at most every 8 s) once the cart has something in it */
if (Date.now() - SEED_AT < 8000) return;
SEED_AT = Date.now();
SEEDING = true;
fetch('/cart?pgx_wallet=' + Date.now(), {credentials: 'same-origin', cache: 'no-store'}).then(function(r){ return r.text(); }).then(function(h){
SEEDING = false;
var doc = new DOMParser().parseFromString(h, 'text/html');
var dc = doc.getElementById('dynamic-checkout-cart');
var s = dc ? (dc.innerHTML || '').trim() : '';
if (usable(s)){ MARKUP = s; SEEDED = true; memoPut(s); }
else if (walletCount(s) > 0 && doc.querySelector('#cart .l4ca:not(.in-panel) > li, .form-cart .l4ca:not(.in-panel) > li')) memoPut('none:' + Date.now());
if (MARKUP && !(window.customElements && customElements.get('shopify-accelerated-checkout-cart'))){
try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init(); } catch (e){}
}
if (MARKUP) setTimeout(place, 50);
}).catch(function(){ SEEDING = false; });
}

var TOKEN = '';
  function token(){
    if (TOKEN) return Promise.resolve(TOKEN);
    return fetch('/cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ TOKEN = String((c && c.token) || '').split('?')[0]; return TOKEN; });
  }

  function build(tok){
    var tmp = document.createElement('div');
    tmp.innerHTML = MARKUP;
    var comp = tmp.querySelector('shopify-accelerated-checkout-cart');
    if (!comp) return null;
    var cfg;
    try { cfg = JSON.parse(comp.getAttribute('wallet-configs') || '[]'); } catch (e){ return null; }
    cfg = cfg.filter(function(w){ return w && KEEP[w.name]; });
    if (!cfg.length) return null;
    comp.setAttribute('wallet-configs', JSON.stringify(cfg));
    if (tok) comp.setAttribute('cart-id', tok);
    /* the markup carries one grey placeholder per wallet the STORE has (four);
       keep as many as will be drawn, so four bars do not flash in the pane */
    var cells = tmp.querySelectorAll('.wallet-cart-button-container');
    for (var i = cells.length - 1; i >= cfg.length; i--){
      if (cells[i].parentNode) cells[i].parentNode.removeChild(cells[i]);
    }
    var wrap = document.createElement('div');
    wrap.className = 'pg-xpay';
    while (tmp.firstChild) wrap.appendChild(tmp.firstChild);
    return wrap;
  }

  /* the wallet row takes the Checkout button's height, whatever the theme makes
     it, and follows it if it changes (the drawer opening, a rotated phone) */
  function fit(p, wrap){
    var b = p.querySelector('form.f8vl button') || p.querySelector('form button');
    if (!b) return;
    function set(){
      var h = Math.round(b.getBoundingClientRect().height);
      /* 9px slimmer than Secure Checkout (2026-09-19, "make the apple pay thing, same with google pay, a little slimmer than the secure checkout button") */
      if (h >= 40 && h <= 64) wrap.style.setProperty('--pg-xpay-h', Math.max(36, h - 9) + 'px');
    }
    set();
    if (window.ResizeObserver){ try { new ResizeObserver(set).observe(b); } catch (e){} }
    /* 2026-09-27 (owner: "the badges under the secure checkout are like going into the button's shadow"): Safari without Apple Pay draws no wallet, so the card-icon row sat about 14px under Secure Checkout and its white band cut through the button's purple glow. data-on says whether a wallet button actually drew, and the section CSS spaces the icons from it. */
    function mark(){ var on = wrap.offsetHeight > 20 ? '1' : '0'; if (wrap.getAttribute('data-on') !== on) wrap.setAttribute('data-on', on); }
    mark(); [400, 1500, 4000].forEach(function(t){ setTimeout(mark, t); });
    if (window.ResizeObserver){ try { new ResizeObserver(mark).observe(wrap); } catch (e){} }
  }

  function paneOf(){
    var cart = document.getElementById('cart');
    return cart ? cart.querySelector('.sticky-in-panel') : null;
  }
  /* the trust row under the buttons, and the button named for what it is.
     Moves and writes only when something is out of place, so the observer that
     calls this is not fed by it. */
  function tidy(p){
    var form = p.querySelector('form.f8vl') || p.querySelector('form');
    if (!form || form.parentNode !== p) return;
    var b = form.querySelector('button[name="checkout"]');
    if (b){
      var spans = b.querySelectorAll('span:not(.processing):not(.processed)');
      for (var i = 0; i < spans.length; i++){
        if ((spans[i].textContent || '').replace(/\s+/g, ' ').trim() === 'Checkout') spans[i].textContent = 'Secure Checkout';
      }
    }
    var t = p.querySelector('.nc-dtrust');
    if (!t) return;
    var x = p.querySelector('.pg-xpay');
    var after = (x && x.parentNode === p) ? x : form;
    if (after.nextElementSibling !== t) p.insertBefore(t, after.nextSibling);
  }

  var placing = false;
  function place(){
    var cart = document.getElementById('cart');
    var pane = paneOf();
    if (!cart || !pane) return;
    try { tidy(pane); } catch (e){}
    var has = !!cart.querySelector('.l4ca:not(.in-panel) > li');
    var mine = pane.querySelector('.pg-xpay');
    if (!has){ if (mine && mine.parentNode) mine.parentNode.removeChild(mine); return; }
    if (mine || placing) return;
if (!MARKUP){ seed(); return; }
    placing = true;
    token().then(function(tok){
      placing = false;
      /* the drawer may have been rebuilt while the id was on its way */
      var p = paneOf();
      if (!p || p.querySelector('.pg-xpay')) return;
      var wrap = build(tok);
      if (!wrap) return;
      fit(p, wrap);
      var form = p.querySelector('form.f8vl') || p.querySelector('form');
      if (form && form.parentNode === p) p.insertBefore(wrap, form.nextSibling);
      else p.appendChild(wrap);
      try { tidy(p); } catch (e){}
    }).catch(function(){ placing = false; });
  }

  function boot(){
    /* 2026-10-13 (speed): the load-time read only where the 2026-09-24 symptom is (no component in the holder at all). A holder WITH a component but without Apple/Google Pay means this browser is offered neither, and the /cart page lists the same wallets, so that read was 728 KB downloaded and parsed for nothing on every page view. place() below still seeds the moment the drawer holds a line. */
    if (!HOLDER_COMP) seed();
    place();
    document.addEventListener('pg:cart-updated', function(){ try { place(); } catch (e){} });
    (function watch(){
      var c = document.getElementById('cart');
      if (!c || !window.MutationObserver){ setTimeout(watch, 600); return; }
      var queued = false;
      new MutationObserver(function(){
        if (queued) return;
        queued = true;
        setTimeout(function(){ queued = false; try { place(); } catch (e){} }, 60);
      }).observe(c, {childList: true, subtree: true});
    })();
    [800, 2500].forEach(function(t){ setTimeout(place, t); });
  }
  window.__pgxExpress = {seed: seed, place: place, state: function(){ return {markup: MARKUP.length, seeded: SEEDED, seeding: SEEDING, seedAt: SEED_AT, placing: placing}; }}; /* debug handle, harmless */
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
